import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      // Get the initial session
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        // Check if this is a recovery session by looking at the AMR
        const token = session.access_token;
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const isRecovery = tokenData.amr?.some(
          (method: { method: string }) => method.method === 'recovery'
        );

        if (isRecovery) {
          navigate('/auth/reset-password', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } else {
        navigate('/auth', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50">
      <div className="animate-pulse text-stone-500">Authenticating...</div>
    </div>
  );
};

export default AuthCallback;